import Guid from '@/app/utils/guid'
import Address from '@/locations/models/address'
import Entity from '@/common/models/entity'

export default class User extends Entity {
  public userName = ''
  public email = ''
  public tenantId = Guid.empty()
  public role = 'USER'
  public salutation = 'Mrs'
  public title = 'Mag'
  public firstName = ''
  public lastName = ''
  public companyName = ''
  public address = new Address()
  public isDeleted = false
  public remarks = ''
  public radiusOfInterest: number = 50
  public automaticNewsfeedEnabled = true
  public automaticNewsfeedEnabledForUnlocated = true
  public receiveNewsletters = true
  public lastLoginDate: Date | null = null
  public phoneNumber = ''
  public created: Date | null = null
  public cancellationDate: Date | null = null
  public firstAcceptedDate: Date | null = null
  public twoFactorEnabled = false
  public twoFactorEmail = ''
  public alreadyInvoiced = false
}
